const messages = {
  seasons: {
    all: "Sve sezone",
    summer: "Leto",
    winter: "Zima",
    general: "Opšte",
  },
  offer:
    "Redovno proširujemo naše <br />ponude za vas! <br /><br />Obavestićemo vas o novim kursevima za obuku u vašoj primljenoj pošti.",
  summary: {
    congratulations: "ČESTITAMO - ZAVRŠILI STE VAŠU EKSPERTIZU O",
    participation:
      "Uspešno ste završili onlajn obuku za Transporter gume za sve sezone.",
    certificate:
      "Vaš certifikat će vam biti poslat email-om ili možete direktno preuzeti kao PDF ovde:",
    send: "Preuzmite certifikat",
  },
  online: {
    title: "Naši onlajn treninge",
    desc: "Osigurajte ekspertsko znanje i, nakon uspešnog završetka odgovarajućih testova za obuku, vaš<br> lični certifikat o učestvovanju kao i 40 dodatnih poena za premium klub po prvi put",
    content:
      "Otkrijte naše trenutne onlajn treninge sada i učestvujte odmah na platformi ovde:",
    categories: {
      title: "Onlajn trening",
      description:
        "Ostanite ispred sa znanjem: Osigurajte ekskluzivnu ekspertizu za vas i vaš tim sa našim ponudama obuke. Bilo da su to naše onlajn sesije obuke, kojima možete direktno učestvovati na platformi, naši kursevi i praktični seminari u Bridgestone centru za obuku, ili čak spoljašnji trening čiji troškovi mogu biti smanjeni vašim premium poenima.",
      general: {
        title: "Opšte",
        subtitle: "Onlajn trening: Opšte",
        description:
          "Otkrijte najnovije tehnologije, važne razvoje u industriji guma, savete za vašu prodaju, i još mnogo toga.",
        subdesription:
          "Osigurajte ekspertsko znanje i, nakon uspešnog završetka odgovarajućih testova obuke, vaš lični certifikat o učestvovanju kao i jednokratni bonus od 40 dodatnih poena za premium klub.",
      },
      product: {
        title: "Proizvodi",
        subtitle: "Onlajn trening: Proizvodi",
        description:
          "Produbite vašu Bridgestone i Firestone ekspertizu o proizvodima za uspešnu prodaju sa našim kompaktnim video obukama.",
        subdesription:
          "Osigurajte ekspertsko znanje i, nakon uspešnog završetka odgovarajućih testova obuke, vaš lični certifikat o učestvovanju kao i jednokratni bonus od 40 dodatnih poena za premium klub.",
      },
    },
  },
  lectures: {
    title: "Bridgestone treninge",
    desc: "Proširite vašu ekspertizu i rezervišite naše treninge i intenzivne treninge za vas i vaš tim. Imate opciju da učestvujete u treningima u Bridgestone centru kompetencija i obuke u Dietzenbachu (blizu Frankfurta na Majni) ili, za odabrane treninge, da se oni provode u vašoj kompaniji. Možete koristiti vaše bonus poene za treninge i tako pokriti troškove u celosti ili delimično vašim poenima.",
    content: "Otkrijte naše trenutne treninge sada i zatražite rezervaciju:",
  },
  singleLecture: {
    registerForm: {
      title: "Sadržaj treninga",
      inquiry: "Upit",
      interested: "Zainteresovan sam za trening",
      participantsNr: "Broj učesnika",
      pointsFromBalance: "Želim koristiti poene iz mog stanja poena.",
      reduction: "Ovo odgovara smanjenju troškova od {points} eura.",
      request: "Pošaljite upit",
    },
    success: {
      thanks: "Hvala vam",
      title: "Vaš upit je poslat timu za obuku.",
      feedbackTime:
        "Primićete odgovor u roku od 14 dana da razjasnimo sve detalje.",
      points:
        "Korišćeni bonus poeni u iznosu od<br /><strong>{points}</strong> poena su oduzeti sa vašeg<br />računa poena.",
      refund:
        "Ako trening ne bude održan, poeni će naravno biti vraćeni na vaš račun.",
      queries: "Za pitanja, molimo kontaktirajte:",
    },
    index: {
      costs: "Troškovi i informacije o učestvovanju",
      duration: "Trajanje: {duration}",
      cost: "Troškovi {cost}: {price} eura",
      participantsNr: "Učesnici: min. {min} - max. {max} ljudi",
    },
  },
  index: {
    title: "Trening i obrazovanje",
    desc: "Prednost kroz znanje: Osigurajte ekskluzivno stručno znanje za vas i vaš tim sa našim ponudama obuke. Bilo sa našim onlajn treningom, kojem možete direktno učestvovati na platformi, sa našim treningom i praktičnim seminarima u Bridgestone centru za obuku ili sa spoljašnjim treningom, čiji troškovi možete smanjiti vašim nagradnim poenima.",
    online: {
      title: "Onlajn treninge",
      desc: "Učestvujte direktno na platformi i osigurajte {points} poena za premium klub.",
    },
    lectures: {
      title: "Treninge",
      desc: "Visokokvalitetni treninge u našem centru za obuku ili na vašoj lokaciji.",
    },
    external: {
      title: "Spoljašnji treninge",
      desc: "Koristite bonus poene za ponude od trećih strana i smanjite troškove.",
    },
  },
  single: {
    done: "Trening je zavrsen.",
    doneDownloadCertificate: "Trening je zavrsen. Preuzmi sertifikat.",
  },
  certificate: {
    header: "CERTIFIKAT",
    atCourse: "je uspešno učestvovao/la u",
    takePart: "kursu.",
    contains: "KOMPONENTE KURSA",
    country: "Velika Britanija",
  },
};

export default {
  messages,
};
